const DOCUMENT = 'AUTOMATION_CONFIG_';

const actions = {
  CANCEL: DOCUMENT + 'CANCEL',
  CHANGE_PRIORITY_PRICING_PROPERTY: DOCUMENT + 'CHANGE_PRIORITY_PRICING_PROPERTY',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CHANGE_NESTED_PROPERTY: DOCUMENT + 'CHANGE_NESTED_PROPERTY',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  TOUCH: DOCUMENT + 'TOUCH',
  UPDATE: DOCUMENT + 'UPDATE',
  LOAD_FORM_DATA_REQUEST: DOCUMENT + 'LOAD_FORM_DATA_REQUEST',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  LOAD_FORM_DATA_ERROR: DOCUMENT + 'LOAD_FORM_DATA_ERROR',
  UPDATE_SUCCESS: DOCUMENT + 'UPDATE_SUCCESS',

  cancel: () => ({ type: actions.CANCEL }),

  changeProperty: payload => ({ type: actions.CHANGE_PROPERTY, payload }),

  clearStore: () => ({ type: actions.CLEAR_STORE }),

  loadData: payload => ({ type: actions.LOAD, payload }),

  loadDataSuccess: payload => ({ type: actions.LOAD_SUCCESS, payload }),

  onChangePriorityPricingProperty: payload => ({ type: actions.CHANGE_PRIORITY_PRICING_PROPERTY, payload }),

  onChangeNestedProperty: payload => ({ type: actions.CHANGE_NESTED_PROPERTY, payload }),

  touch: payload => ({ type: actions.TOUCH, payload }),

  update: payload => ({ type: actions.UPDATE, payload }),

  updateSuccess: payload => ({ type: actions.UPDATE_SUCCESS, payload }),

  loadFormDataRequest: () => ({ type: actions.LOAD_FORM_DATA_REQUEST }),

  loadFormDataSuccess: payload => ({ type: actions.LOAD_FORM_DATA_SUCCESS, payload }),

  loadFormDataError: payload => ({ type: actions.LOAD_FORM_DATA_ERROR, payload }),
};

export default actions;
